import { CurrentUserStore, User, UserConfig } from "../types/users";
import { user as api } from "../api/current.user";
import { config as configApi } from "../api/user.config.api";

export const state: CurrentUserStore = {
	errorMessage: null,
	isFetching: false,
	lastFetched: null,
	user: null,
	dashboards: [],
	domain: null,
	config: {},
	notifications: null
};

export const getters = {
	get: (state): User => state.user as User,
	config: (state) => state.config as UserConfig,
	domain: (state): string => state.domain as string,
	fetching: (state): boolean => state.isFetching as boolean,
	errorMessage: (state): string => state.errorMessage as string,
	token: (): string => (localStorage.getItem("token") || null) as string,
	intercom: (): string => (localStorage.getItem("intercom") || null) as string,
	intercomData: (state, getters) => null,
	datalayer: (state, getters, rootState, rootGetters) => {
		const user = state.user;
		return user
			? {
					userId: user.id,
					userEmail: user.email,
					userFirstName: user.firstname,
					userLastName: user.lastname,
					userJobTitle: user.jobtitle,
					userPhone: user.phone,
					dnt: navigator.doNotTrack
			  }
			: null;
	},
	terms: (state, getters) => getters.config.terms as Boolean,
	notifications: (state) => state.notifications && state.config.meetingsenabled
};
export const actions = {
	async set({ commit, dispatch, getters }, userDetails) {
		const { user, intercom, token, domain } = userDetails;

		if (user) {
			commit("SET_USER", user);
		}

		if (token) {
			commit("SET_TOKEN", token);
		}

		if (intercom) {
			commit("SET_INTERCOM_KEY", intercom);
		}

		if (domain) {
			commit("SET_DOMAIN", domain);
		}

		if (user) {
			// now we logged in the user lets fire the information off to the dataLayer
			dispatch("datalayer/push", getters.datalayer, { root: true });

			const _configuration = await configApi.get(user.id);
			commit("SET_USER_CONFIG", _configuration);
		}
		// If this hook is set then we can use in the application to load/do other things
		if (this._actions["userModule/setAfterHook"]) {
			dispatch("userModule/setAfterHook", userDetails, { root: true });
		}
	},
	async refresh({ dispatch }) {
		await api
			.refresh()
			.then((details) => dispatch("set", details))
			.catch((error) => {
				if (
					(error.response && error.response.status === 403) ||
					error.response.status === 422
				) {
					dispatch("clear");
					(window as any).location = "/login";
				}
			});
	},
	clear({ commit }) {
		commit("RESET_USER");
	},
	async update({ state, commit, dispatch }, { user, preferences }) {
		const response = await api.update(user);

		commit(`SET_USER`, response);

		if (preferences) {
			const config = { ...state.config, ...preferences };
			const _config = await configApi.update(config);
			commit("SET_USER_CONFIG", _config);
		}

		dispatch(
			"datalayer/push",
			{
				event: "formSubmitSuccess",
				formType: `UserEdit`
			},
			{ root: true }
		);
	},
	async agree({ commit, state }) {
		const confirm = { ...state.config, terms: true };
		const _config = await configApi.update(confirm);
		commit(`UPDATE_TERMS`, _config);
	}
};
export const mutations = {
	SET_USER(state: CurrentUserStore, user: User) {
		state.user = user;
		state.lastFetched = Date.now();
		state.isFetching = false;
	},
	SET_TOKEN(state: CurrentUserStore, token: string) {
		if (window.localStorage) {
			window.localStorage.setItem("token", token);
		}
	},
	SET_INTERCOM_KEY(state: any, key: string) {
		if (window.localStorage) {
			window.localStorage.setItem("intercom", key);
		}
	},
	SET_DOMAIN(state: CurrentUserStore, domain: string) {
		state.domain = domain;
	},
	LOAD_START(state: CurrentUserStore) {
		state.errorMessage = null;
		state.isFetching = true;
	},
	LOAD_FAILURE(state: CurrentUserStore, message: string) {
		state.errorMessage = message;
		state.isFetching = false;
	},
	RESET_USER(state: CurrentUserStore) {
		state.user = null;
		state.errorMessage = null;
		window.localStorage.clear();
		// window.localStorage.removeItem("intercom");
		// window.localStorage.removeItem("token");
	},
	SET_USER_CONFIG(state, configuration: UserConfig) {
		state.config = configuration;
	},
	UPDATE_TERMS(state, config: UserConfig) {
		state.config = config;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
